import { useSite } from "@/context/SiteContext";
import { FadeUp, SectionHeading } from "@/components/Reveal";

const CaseStudies = () => {
    const { content } = useSite();
    const { cases } = content;

    return (
        <section id="case-studies" data-testid="case-studies-section" className="bg-mist py-20 sm:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHeading eyebrow="Case Studies" heading={cases.heading} sub={cases.sub} />

                <div className="mt-14 grid gap-6 lg:grid-cols-3">
                    {cases.items.map((item, i) => (
                        <FadeUp key={item.company} delay={i * 0.12}>
                            <article
                                data-testid={`case-card-${i}`}
                                className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                            >
                                <div className="flex items-center justify-between gap-3">
                                    <span className="rounded-full bg-amberct/15 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-amber-700">
                                        {item.tag} case study
                                    </span>
                                    <span className="text-xs font-medium text-slate-400">{item.size}</span>
                                </div>
                                <h3 className="mt-4 font-display text-lg font-bold leading-snug text-navy">{item.company}</h3>

                                <dl className="mt-5 space-y-4 text-sm leading-relaxed">
                                    <div>
                                        <dt className="text-xs font-bold uppercase tracking-widest text-slate-400">Challenge</dt>
                                        <dd className="mt-1 text-slate-600">{item.challenge}</dd>
                                    </div>
                                    <div>
                                        <dt className="text-xs font-bold uppercase tracking-widest text-slate-400">Solution</dt>
                                        <dd className="mt-1 text-slate-600">{item.solution}</dd>
                                    </div>
                                    <div>
                                        <dt className="text-xs font-bold uppercase tracking-widest text-slate-400">Result</dt>
                                        <dd className="mt-1 text-slate-600">{item.result}</dd>
                                    </div>
                                </dl>

                                <div className="mt-auto border-t border-slate-100 pt-5">
                                    <p className="font-display text-3xl font-extrabold text-royal">{item.metric}</p>
                                    <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">{item.metricLabel}</p>
                                </div>
                            </article>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CaseStudies;
